// Concepts per level (band), per domain — transcribed from the vault:
//   E:\BRAIN BUFFS\10 Curriculum\Band Structure — Reading Domains.md (info/craft/expression)
//   E:\BRAIN BUFFS\50 Grammar (SEC)\sec-grammar-band-structure.md (conventions)
// `first: true` = the concept's first appearance -> full learn cycle (in-depth lesson);
// `first: false` = re-appearance -> targeted mini-lesson (harder material or new sub-type).
// The SEC ladder is a spiral: every entry teaches a topic at a new complexity, so all first.
// Math domains aren't laddered in the vault yet; they fall back to the teacher band-guide
// skills below (mock until the curriculum team writes real ladders).

import { BAND_GUIDES } from '../../TeacherDashboardV3/data/bandGuides';

const c = (name, first = false) => ({ name, first });

const READING_LADDERS = {
  info: [
    [c('Argument Awareness', true), c('Same Idea, Different Words', true), c('Referent Tracking', true)],
    [c('Evidence: Literary', true), c('Evidence: Quantitative', true)],
    [c('Evidence: Scientific', true), c('Details', true)],
    [c('Central Ideas', true), c('Evidence: Quantitative')],
    [c('Inferences', true), c('Evidence: Quantitative')],
    [c('Inferences'), c('Evidence: Literary'), c('Evidence: Quantitative')],
    [c('Inferences'), c('Evidence: Scientific'), c('Evidence: Quantitative')],
  ],
  craft: [
    [c('Whole-Sentence Reading', true), c('Topic + So What?', true), c('Vocabulary Foundations', true)],
    [c('Words in Context', true), c('Function of a Sentence', true)],
    [c('Words in Context'), c('Purpose of a Passage', true)],
    [c('Words in Context'), c('Function of a Sentence'), c('Structure of a Passage', true)],
    [c('Words in Context'), c('Purpose of a Passage'), c('Cross-Text Connections', true)],
    [c('Words in Context'), c('Function of a Sentence'), c('Cross-Text Connections')],
    [c('Words in Context'), c('Cross-Text Connections'), c('Structure of a Passage')],
  ],
  expression: [
    [c('Transition Signposts', true), c('Reading Student Notes', true)],
    [c('Transitions', true)],
    [c('Transitions'), c('Rhetorical Synthesis', true)],
    [c('Transitions'), c('Rhetorical Synthesis')],
    [c('Transitions'), c('Rhetorical Synthesis')],
    [c('Transitions'), c('Rhetorical Synthesis')],
    [c('Transitions'), c('Rhetorical Synthesis')],
  ],
  conventions: [
    [c('Verbs & Nouns', true), c('The Rest of the Toolkit', true), c('What Makes a Sentence', true)],
    [c('Sentence vs. Fragment', true), c('Subject-Verb Agreement I', true), c('Verb Formation', true)],
    [c('Tense Consistency', true), c('Apostrophes', true), c('Pronoun Agreement I', true)],
    [c('Joining & Separating Sentences', true), c('Commas with Supplementary Phrases', true), c('Pronoun Agreement II', true)],
    [c('Punctuating Conjunctive Adverbs', true), c('Non-Essential Elements with Commas', true), c('Non-Essential with Dashes & Parentheses', true), c('Tense II', true)],
    [c('Colons & Single Dashes', true), c('Eliminating Unnecessary Punctuation', true), c('Subtle Boundaries', true), c('Relative Pronouns', true)],
    [c('Subject-Verb Agreement II', true), c('Essential Elements & the Advanced Colon', true), c('Modification, Parallelism & Comparison', true)],
  ],
};

export function conceptsFor(domainKey, level) {
  const ladder = READING_LADDERS[domainKey];
  if (ladder) return ladder[level - 1] || [];
  // mock - math: derive from the teacher band-guide skills until real ladders exist
  const band = (BAND_GUIDES[domainKey] || [])[level - 1];
  return (band?.skills || ['Core skills']).slice(0, 3).map((name) => c(name, true));
}
